/**
 * Normalized pick-the-positives score (0-100): 10 per correct pick, minus the
 * given penalties for each missed positive and each false positive, over
 * 10 * positives. With no positives present the task is trivially perfect.
 */
export function calculatePickScore(
  items: readonly { positive: boolean }[],
  selected: ReadonlySet<number>,
  missPenalty: number,
  falsePositivePenalty: number,
): number {
  const positives = items.filter((item) => item.positive).length;
  if (positives === 0) {
    return 100;
  }
  const { correct, missed, falsePositive } = items.reduce(
    (acc, item, index) => {
      const picked = selected.has(index);
      if (item.positive && picked) return { ...acc, correct: acc.correct + 1 };
      if (item.positive) return { ...acc, missed: acc.missed + 1 };
      if (picked) return { ...acc, falsePositive: acc.falsePositive + 1 };
      return acc;
    },
    { correct: 0, missed: 0, falsePositive: 0 },
  );
  const earned = 10 * correct - missPenalty * missed - falsePositivePenalty * falsePositive;
  return Math.min(100, Math.max(0, Math.round((100 * earned) / (10 * positives))));
}
